import { Component, OnInit, Input, ElementRef } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-mensaje',
  templateUrl: './modal-mensaje.component.html',
  styleUrls: ['./modal-mensaje.component.css']
})
export class ModalMensajeComponent implements OnInit {

  @Input() public Titulo;
  @Input() public Mensaje;

  constructor(public activeModal: NgbActiveModal, private routers: Router
  ) {
  }

  ngOnInit() {
  }

  Close() {
    this.activeModal.close();
    // const datos = JSON.parse(sessionStorage.params);
    // this.routers.navigate(['/Cotacao'], {
    //   queryParams: {
    //     SalesChannelType: datos.SalesChannelType,
    //     SalesChannelCode: datos.SalesChannelCode,
    //     UserName: datos.UserName,
    //     ambiente: datos.ambiente
    //   }
    // });
  }

}
